import { useTranslation } from 'next-i18next';
import { useMemo } from 'react';
import Accordion from '@/components/Accordion';
import LandingTitle from '@/components/text/LandingTitle';
import StyledText from '@/components/text/StyledText';
import useDeviceSize from '@/hooks/mobile/useDeviceSize';
import SectionHomePage from './SectionHomePage';

export default function QnaSection() {
  // device size
  const deviceSize = useDeviceSize();

  // translate
  const { t } = useTranslation('home', {
    keyPrefix: 'qna',
  });

  // memo
  const contents = useMemo(
    () =>
      (
        t('contents', { returnObjects: true }) as {
          header?: string;
          body?: string;
        }[]
      ).map(({ header, body }) => ({
        header,
        body: (
          <StyledText
            $fontSize="inherit"
            $fontWeight="inherit"
            $color="inherit"
            $whiteSpace="pre-wrap"
          >
            {body}
          </StyledText>
        ),
      })),
    [t]
  );

  return (
    <SectionHomePage height="unset" gap={64}>
      <LandingTitle>{t('title')}</LandingTitle>

      <Accordion
        width={deviceSize === 'mobile' ? '100%' : 728}
        items={contents}
      />
    </SectionHomePage>
  );
}
